  // function showMap(location, event) {
  //   event.preventDefault();

  //   // Remove any existing maps
  //   document.getElementById('mapContainer').innerHTML = '';

  //   // Create the iframe element for the selected location
  //   var iframe = document.createElement('iframe');
  //   iframe.setAttribute('width', '50%');
  //   iframe.setAttribute('height', '450');
  //   iframe.setAttribute('style', 'border:0;');
  //   iframe.setAttribute('allowfullscreen', '');
  //   iframe.setAttribute('loading', 'lazy');
  //   iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');

    // // Set the appropriate source URL based on the selected location
    // if (location === 'Tacoma') {
    //   iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.123448919644!2d-122.50605942326087!3d47.233731113651096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5491ab41759ab17f%3A0xf7d87d71b86afc96!2sThe%20Phone%20Guys%20Tacoma!5e0!3m2!1sen!2sus!4v1691452769823!5m2!1sen!2sus');
    // } else if (location === 'Federal Way') {
    //   iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2706.029868482168!2d-122.31925582325829!3d47.29421590949643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905740651d4dc9%3A0x9434195676c416d8!2sThe%20Phone%20Guys%20-%20Federal%20Way!5e0!3m2!1sen!2sus!4v1691452789127!5m2!1sen!2sus');
    // } else if (location === 'Renton') {
    //   iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2697.0031428848615!2d-122.21579972325068!3d47.47036819737461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905dc2bfa5bee1%3A0x3bc170b31a5bc4df!2sThe%20Phone%20Guys%20-%20Renton!5e0!3m2!1sen!2sus!4v1691452818922!5m2!1sen!2sus');
    // } else if (location === 'Lacey') {
    //   iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2719.0094995609593!2d-122.82945769999999!3d47.0400444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54910b98d61114c9%3A0x1fd8e30cc03989bd!2sThe%20Phone%20Guys%20-%20Lacey!5e0!3m2!1sen!2sus!4v1691452889563!5m2!1sen!2sus');
    // } else if (location === 'Everett') {
    //   iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2675.7735872557205!2d-122.24054332323284!3d47.88271066886965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549007afff5ca66d%3A0x87b98a508b48179!2sThe%20Phone%20Guys%20-%20Everett!5e0!3m2!1sen!2sus!4v1691452835228!5m2!1sen!2sus');
    // }

  //   // Append the iframe to the map container
  //   document.getElementById('mapContainer').appendChild(iframe);
  // }
  // // Call the showMap function with 'Federal Way' as the default location when the page loads
  // document.addEventListener('DOMContentLoaded', function () {
  //   showMap('Federal Way', null);
  // });
  function showMap(location, event) {
    // Check if event is defined (i.e., clicked event)
    if (event) {
      event.preventDefault();
    }

    // Remove any existing maps
    document.getElementById('mapContainer').innerHTML = '';

    // Create the iframe element for the selected location
    var iframe = document.createElement('iframe');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '300'); // Adjust the height here (e.g., 300px)
    iframe.setAttribute('style', 'border:0;');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');

// Set the title attribute for the iframe
  iframe.setAttribute('title', 'Map of ' + location);
    
    // Set the appropriate source URL based on the selected location
    if (location === 'Tacoma') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.123448919644!2d-122.50605942326087!3d47.233731113651096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5491ab41759ab17f%3A0xf7d87d71b86afc96!2sThe%20Phone%20Guys%20Tacoma!5e0!3m2!1sen!2sus!4v1691452769823!5m2!1sen!2sus');
    } else if (location === 'Federal Way') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2706.029868482168!2d-122.31925582325829!3d47.29421590949643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905740651d4dc9%3A0x9434195676c416d8!2sThe%20Phone%20Guys%20-%20Federal%20Way!5e0!3m2!1sen!2sus!4v1691452789127!5m2!1sen!2sus');
    } else if (location === 'Renton') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2697.0031428848615!2d-122.21579972325068!3d47.47036819737461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54905dc2bfa5bee1%3A0x3bc170b31a5bc4df!2sThe%20Phone%20Guys%20-%20Renton!5e0!3m2!1sen!2sus!4v1691452818922!5m2!1sen!2sus');
    } else if (location === 'Lacey') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1922.5834431990336!2d-122.83194350316926!3d47.04133790420976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54910b37c896a935%3A0xb5de078a55609805!2s700%20Sleater%20Kinney%20Rd%20SE%20H%2C%20Lacey%2C%20WA%2098503!5e0!3m2!1sen!2sus!4v1716507364046!5m2!1sen!2sus');
    } else if (location === 'Everett') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2675.7735872557205!2d-122.24054332323284!3d47.88271066886965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549007afff5ca66d%3A0x87b98a508b48179!2sThe%20Phone%20Guys%20-%20Everett!5e0!3m2!1sen!2sus!4v1691452835228!5m2!1sen!2sus');
    }  else if (location === 'Puyallup') {
      iframe.setAttribute('src', 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5425.964041367125!2d-122.3044011053875!3d47.158206549741045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490fd453f7c5d85%3A0x8155e2b5edb60656!2sThe%20Phone%20Guys!5e0!3m2!1sen!2sus!4v1713643548891!5m2!1sen!2sus');
    }

    // Append the iframe to the map container
    document.getElementById('mapContainer').appendChild(iframe);
  }

  // Call the showMap function with 'Federal Way' as the default location when the page loads
  document.addEventListener('DOMContentLoaded', function () {
    showMap('Federal Way', null);
  });